import React from 'react';
import DetectTouch from '../partials/global/DetectTouch';
import ViewportFix from '../partials/global/ViewportFix';
import Cover from '../partials/global/Cover';
import Header from '../partials/global/Header';
import Front from '../partials/front/Front';
import Info from '../partials/information/Info';
import Contact from '../partials/contact/Contact';
import Work from '../partials/work/Work';
import {Provider} from '../context/Context'

const TplIndex = (props) => {  
		
	let block = null;
	
	if (props.match.path === '/work/:slug') {
		block = <Work></Work>;
	} else if (props.match.path === '/work') {
		block = <Work></Work>;
	} else if (props.match.path === '/information') {
		block = <Info></Info>;
	} else if (props.match.path === '/contact') {
		block = <Contact></Contact>;
	} else if (props.match.path === '/') {
		block = <Front></Front>;
	}
    
    if (block) {
		return (
			<Provider router={props}>
				<DetectTouch></DetectTouch>
				<ViewportFix></ViewportFix>
				<Cover></Cover>
				<Header></Header>
				{ block }
			</Provider>
		)    
	} else {
		return null;
	}
}
export default TplIndex